import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { environment } from "../../../../environments/environment";
import { Document } from "./document.model";
import { HttpClient, HttpParams } from "@angular/common/http";

const API_ENDPOINT = environment.API_ENDPOINT + "/documents";

@Injectable()
export class DocumentsService {
  patients: Observable<Array<Document>>;

  constructor(private http: HttpClient) {}

  listDocuments(): Observable<Document[]> {
    return this.http.get<Document[]>(API_ENDPOINT);
  }

  getDocument(document: Document): Observable<Document> {
    let params: HttpParams = new HttpParams();

    if (document.isDefault) {
      params = params.append("default", "true");
    }

    return this.http.get<Document>(API_ENDPOINT + "/" + document.id, {
      params,
    });
  }

  createDocument(document: Document): Observable<Document> {
    return this.http.post<Document>(API_ENDPOINT, document);
  }

  updateDocument(document: Document): Observable<Document> {
    return this.http.put<Document>(API_ENDPOINT + "/" + document.id, document);
  }

  deleteDocument(document: Document): Observable<Document> {
    return this.http.delete<Document>(API_ENDPOINT + "/" + document.id);
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/document/document.service.ts